import { Box, styled } from '@mui/material';

const Container = styled(Box)`
  width: 100%;
  height: 300px;
  display: flex;

  justify-content: center;
  align-items: center;
`;

export default Container;
